import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-image',
    templateUrl: 'image.component.html',
    /* host: { 'class': 'pull-left' } */
})

export class ImageComponent implements OnInit {

    @Input('downloadURL') downloadURL: any;
    @Input('width') width: number;
    @Input('height') height: number;
    @Input('padding') padding: number;
    @Input('verticalAlign') verticalAlign: string = 'top';
    @Input('imgClass') imgClass: string;
    @Input('class') class: string;
    @Input('fileName') fileName: string;

    public showFileName: boolean;
    public fileExtension: string;
    public requestedURL: string;
    public showError: boolean;
    public subscription: any;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit() {
        if (this.fileName) {
            this.fileExtension = /(?:\.([^.]+))?$/.exec(this.fileName)[1].toLowerCase();
            this.showFileName = !/(png|gif|jpg|jpeg)$/ig.test(this.fileExtension);
        }
        if (this.downloadURL && this.downloadURL.subscribe) {
            this.subscription = this.downloadURL.subscribe((url, b, c) => {
                this.requestedURL = url;
                if (!this.changeDetectorRef['destroyed']) {
                    this.changeDetectorRef.detectChanges();
                }
                if (this.subscription) {
                    this.subscription.unsubscribe();
                }
            }, err => {
                console.log('err', err)
                this.showError = true;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/upload/image.component.ts